export const aiModels = [
  {
    id: 'midjourney-v6',
    name: 'Midjourney v6.0',
    type: 'proprietary',
    description: 'Top-performing commercial model for artistic style generation',
    parameters: {
      style: 'raw',
      stylization: 250
    }
  },
  {
    id: 'dalle3',
    name: 'DALL-E 3',
    type: 'proprietary',
    description: 'OpenAI\'s latest text-to-image model via ChatGPT',
    parameters: {
      quality: 'hd',
      style: 'natural'
    }
  },
  {
    id: 'flux-pro',
    name: 'Flux Pro',
    type: 'proprietary',
    description: 'Black Forest Labs high-quality generation model',
    parameters: {
      guidance: 3.5,
      steps: 50
    }
  },
  {
    id: 'sdxl-base',
    name: 'Stable Diffusion XL',
    type: 'open-source',
    description: 'Open-source baseline model without fine-tuning',
    parameters: {
      cfgScale: 7.5,
      steps: 50,
      sampler: 'DPM++ 2M Karras'
    }
  },
  {
    id: 'sdxl-finetuned',
    name: 'SDXL Fine-tuned',
    type: 'open-source-finetuned',
    description: 'SDXL with LoRA fine-tuning on artist-specific corpus',
    parameters: {
      cfgScale: 7.5,
      steps: 50,
      sampler: 'DPM++ 2M Karras',
      loraWeight: 0.8
    }
  }
];

export const getModelById = (modelId) => {
  return aiModels.find(model => model.id === modelId) || aiModels[0];
};

export const getProprietaryModels = () => {
  return aiModels.filter(model => model.type === 'proprietary');
};

export const getOpenSourceModels = () => {
  return aiModels.filter(model => model.type.includes('open-source'));
};